import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, d = /* @__PURE__ */ e('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M8 7.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5ZM6.25 8a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Z"></path><path d="M3.895 8C4.971 9.522 6.502 10.25 8 10.25c1.498 0 3.03-.728 4.105-2.25C11.03 6.478 9.498 5.75 8 5.75c-1.498 0-3.03.728-4.105 2.25ZM8 4.25c2.172 0 4.306 1.15 5.642 3.362a.75.75 0 0 1 0 .776C12.306 10.6 10.172 11.75 8 11.75S3.694 10.6 2.358 8.388a.75.75 0 0 1 0-.776C3.694 5.4 5.828 4.25 8 4.25Z"></path><path d="M.25 2C.25 1.034 1.034.25 2 .25h12c.966 0 1.75.784 1.75 1.75v12A1.75 1.75 0 0 1 14 15.75H2A1.75 1.75 0 0 1 .25 14V2ZM2 1.75a.25.25 0 0 0-.25.25v12c0 .138.112.25.25.25h12a.25.25 0 0 0 .25-.25V2a.25.25 0 0 0-.25-.25H2Z"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs>', 2), h = [
  d
];
function o(p, r) {
  return t(), a("svg", c, [...h]);
}
const l = { render: o };
export {
  l as default,
  o as render
};
